import { Link } from "@tanstack/react-router";
import { BuildingIcon, HomeIcon } from "lucide-react";

import {
	DropdownMenuGroup,
	DropdownMenuItem,
	DropdownMenuLabel,
	DropdownMenuSeparator,
	DropdownMenuSub,
} from "@/components/ui/dropdown-menu";
import { useOrganizations } from "@/hooks/query/organization";
import { useSession } from "@/lib/auth-client";
import * as m from "@/paraglide/messages";

export function OrganizationSwitcher() {
	const { data: session } = useSession();
	const { data: organizations } = useOrganizations();

	const activeOrgId = session?.session?.activeOrganizationId;

	if (!organizations) {
		return null;
	}

	return (
		<>
			<DropdownMenuSeparator />
			<DropdownMenuGroup>
				<DropdownMenuLabel>{m.organizationSettings_title()}</DropdownMenuLabel>
				{organizations.length === 0 ? (
					<DropdownMenuItem
						className="text-xs"
						render={<Link to="/settings/organization" />}
					>
						<HomeIcon className="h-4 w-4 text-muted-foreground" />
						{m.organizationSettings_createOrganization()}
					</DropdownMenuItem>
				) : (
					<DropdownMenuSub>
						{organizations.map((org) => {
							const isActive = org.id === activeOrgId;

							return (
								<DropdownMenuItem
									key={org.id}
									className="text-xs"
									render={
										<Link to="/settings/organization">
											<BuildingIcon className="h-4 w-4" />
											<span className="flex-1 truncate">{org.name}</span>
										</Link>
									}
								/>
							);
						})}
					</DropdownMenuSub>
				)}
			</DropdownMenuGroup>
			<DropdownMenuSeparator />
		</>
	);
}
